// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/chunks/" + chunkId + "." + {"4042":"084f016e","5458":"e2584ac7"}[chunkId] + ".js";
};